module.exports = __webpack_public_path__ + "static/media/logo.af9782ca.png";